import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { Link, useLocation } from "react-router-dom"




interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
    items: {
        href: string
        title: string,
        icon: React.ReactNode
    }[]
    }    

export function SidebarNav({ className, items, ...props }: SidebarNavProps) {
    const location = useLocation();
    const pathname = location.pathname;

    // const pathname = usePath
    return (
        <aside className="-mx-4 lg:w-1/5">
            <nav
            className={cn(
                "flex flex-col space-x-0 lg:space-y-1 gap-2",
                className
            )}
            {...props}
            >
            {items.map((item) => (
                <Link
                    key={item.href}
                    to={item.href}
                className={cn(
                    buttonVariants({ variant: "ghost" }),
                    pathname === item.href
                    ? "bg-muted hover:bg-muted"
                    : "hover:bg-transparent hover:underline",
                    "justify-start"
                )}
                >{item.icon}
                <span>{item.title}</span>
                </Link>
            ))}
            </nav>
        </aside>
    )
    }